import React from 'react';
import { Document, Page, Text, View } from '@react-pdf/renderer';
import {
  styles,
  SimpleTable,
  SummaryBox,
  MedicaoCapa,
  MedicaoCabecalho,
  MedicaoRodape,
  formatDateBrPdf,
  formatInteiroPdf,
  formatNumeroPdf,
} from './pdf/MedicaoPdfBase';

const TITULO = 'MEDIÇÃO - RUPTURA';

const colunasFck = [
  { key: 'fck', label: 'Fck (MPa)', width: '25%', render: (r) => formatNumeroPdf(r.fck) },
  { key: 'qtd', label: "Total de CP's", width: '25%' },
  { key: 'rompidos', label: 'Rompidos', width: '25%' },
  { key: 'previstos', label: 'Previstos (a romper)', width: '25%' },
];

const colunasIdade = [
  { key: 'idade', label: 'Idade (dias)', width: '25%', render: (r) => formatInteiroPdf(r.idade) },
  { key: 'qtd', label: "Total de CP's", width: '25%' },
  { key: 'rompidos', label: 'Rompidos', width: '25%' },
  { key: 'previstos', label: 'Previstos (a romper)', width: '25%' },
];

const colunasCp = [
  { key: 'etiqueta', label: 'Identificador (ID - Etiqueta)', width: '18%' },
  { key: 'dataConcretagem', label: 'Data de moldagem', width: '12%', render: (r) => formatDateBrPdf(r.dataConcretagem) },
  { key: 'dataRuptura', label: 'Data de ruptura', width: '12%', render: (r) => formatDateBrPdf(r.dataRuptura) },
  { key: 'idadeRuptura', label: 'Idade (dias)', width: '8%', render: (r) => formatInteiroPdf(r.idadeRuptura) },
  { key: 'fck', label: 'Fck (MPa)', width: '8%', render: (r) => formatInteiroPdf(r.fck) },
  { key: 'statusLabel', label: 'Situação', width: '10%' },
  { key: 'valrCarga', label: 'Carga', width: '10%', render: (r) => formatNumeroPdf(r.valrCarga) },
  { key: 'fcj', label: 'Resultado (MPa)', width: '12%', render: (r) => formatNumeroPdf(r.fcj) },
  { key: 'tipoRuptura', label: 'Tipo de ruptura', width: '10%', render: (r) => r.tipoRuptura || '-' },
];

// Documento PDF da Medição de Ruptura: capa, resumo (por Fck e por idade) e relação sequencial de CPs do período.
function MedicaoRupturaPDF({
  resumo,
  cps = [],
  empresaNome = '',
  obraNome = '',
  periodo = '',
  logoCliente = null,
  assinaturas = [],
}) {
  const linhasCp = cps.map((cp) => ({
    ...cp,
    key: cp.idCorpoProva,
    etiqueta: cp.etiqueta || '-',
    statusLabel: cp.status === 'rompido' ? 'Rompido' : 'Previsto',
  }));
  const cabecalho = (
    <MedicaoCabecalho titulo={TITULO} logoCliente={logoCliente} empresa={empresaNome} obra={obraNome} periodo={periodo} />
  );
  const rodape = (
    <MedicaoRodape assinaturas={assinaturas} />
  );

  return (
    <Document>
      <MedicaoCapa kicker="MEDIÇÃO" titulo="Medição de Ruptura de Corpos de Prova" empresa={empresaNome} obra={obraNome} periodo={periodo} />

      <Page size="A4" orientation="landscape" style={styles.page}>
        {cabecalho}
        <View style={styles.summaryRow}>
          <SummaryBox value={resumo?.previstos ?? 0} label="Previstos (a romper)" />
          <SummaryBox value={resumo?.rompidos ?? 0} label="Rompidos" />
          <SummaryBox value={resumo?.total ?? 0} label="Total no período" />
        </View>

        <Text style={styles.sectionTitle}>CPs por Fck (classe de resistência à compressão)</Text>
        <SimpleTable columns={colunasFck} rows={(resumo?.porFck ?? []).map((r, i) => ({ ...r, key: `fck-${i}` }))} />

        <Text style={styles.sectionTitle}>CPs por idade de ruptura</Text>
        <SimpleTable columns={colunasIdade} rows={(resumo?.porIdade ?? []).map((r, i) => ({ ...r, key: `idade-${i}` }))} />
        {rodape}
      </Page>

      <Page size="A4" orientation="landscape" style={styles.page}>
        {cabecalho}
        <Text style={styles.sectionTitle}>Corpos de prova do período (ordem de data de ruptura)</Text>
        {linhasCp.length === 0 ? <Text>Nenhum corpo de prova no período.</Text> : <SimpleTable columns={colunasCp} rows={linhasCp} />}
        {rodape}
      </Page>
    </Document>
  );
}

export default MedicaoRupturaPDF;
